<template>
	<div class="container-channel">
		<div class="container-channel-header mb-2">
			Online channel stock
		</div>
		<div class="container-channel-content">
			<BaseLoading v-if="isLoading" />
			<template v-else>
				<CRow class="mb-3">
					<CCol xl="9" class="typo-label">
						Channels
					</CCol>
					<CCol xl="3" class="typo-label">
						Qty
					</CCol>
				</CRow>
				<CRow
					v-for="(item, index) in channels"
					:key="index"
					class="mb-3"
				>
					<CCol xl="9" class="typo-subtitle">
						{{ item.name }}
					</CCol>
					<CCol xl="3" class="typo-subtitle">
						{{ item.qty | numberFormat }}
					</CCol>
				</CRow>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DashboardChannelStockStatus',

	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
		channels: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.container-channel {
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: $color-white;
	border-radius: 4px;
	box-shadow: $showdow-section;

	&-header {
		@include typo-h5;

		padding: rem(16) rem(16) rem(10) rem(16);
		border-bottom: 1px solid $color-gray-300;
	}

	&-content {
		padding: 0 rem(16);
		margin-top: rem(12);
		margin-bottom: rem(16);
	}
}
</style>
